import styled, { css } from 'styled-components';

export const Wrapper = styled.div``;

type MapProps = {
  show?: boolean;
}

export const Map = styled.div<MapProps>`
  width: 100%;
  height: 100%;
  border-radius: 4px;

  > input {
    width: 100% !important;
  }

  ${props => !props.show && css`
    width: 100%;
    height: 100%;
    visibility: hidden;
    border-radius: 4px;

    input {
      width: 23rem;
    }
  `}
`;

export const MapContainer = styled.div`
  width: 100%;
  height: 100%;
  position: relative;

  .leaflet-map {
    width: 100%;
    height: 200px;
    border-radius: 4px;
    margin-top: 0.4rem;
  }
`;

export const MapFocusButton = styled.button`
  width: 2.3rem !important;
  height: 2.3rem !important;
  border: 2px solid rgba(0, 0, 0, 0.2);
  background-clip: padding-box;
  border-radius: 0.3rem;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 12px;
  bottom: 12px;
  z-index: 999;

  &:hover {
    opacity: 0.8;
  }

  svg {
    path,
    circle {
      stroke: var(--black-100);
    }
  }
`;

export const StandaloneContainer = styled.div`
  display: flex;
  flex-direction: row !important;
  margin-bottom: 0px !important;

  .readonly-address {
    background-color: var(--black-400);
    border: 1px dashed var(--primary);
  }

  > div {
    width: 100%;

    > input {
      width: 100%;
    }
  }
`;

export const Label = styled.label`
  color: var(--grey-100);
`;

